import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useCanPage } from '../hooks/usePermission';
import { useAuth } from '../stores/auth';

/**
 * Route-level gate. The backend refuses the data regardless — this exists so a user
 * lands on a clear message instead of an empty screen full of failed requests.
 */
export function RequirePermission({ page, alsoPages = [], children }: { page: string; /** Any of these pages admits too. */ alsoPages?: string[]; children: ReactNode }) {
  const main = useCanPage(page);
  const other = useAuth((s) => alsoPages.some((p) => s.canAccessPage(p)));
  const allowed = main || other;
  if (allowed) return <>{children}</>;
  return (
    <div className="mx-auto max-w-md py-24 text-center">
      <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-ink-100"><Lock className="h-5 w-5 text-ink-500" /></div>
      <h2 className="mt-4 text-[15px] font-semibold text-ink-900">This page isn't in your role</h2>
      <p className="mt-1.5 text-[12.5px] leading-relaxed text-ink-500">
        Your role doesn't include any permission on <code className="rounded bg-ink-100 px-1.5 py-0.5 text-[12px] text-ink-700">{page}</code>. An administrator can grant it from Users → Roles.
      </p>
      <Link to="/app" className="mt-6 inline-block text-[13px] font-medium text-bronze-600 hover:underline">Back to your dashboard</Link>
    </div>
  );
}
